/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForPeriodicZabbixGovernance extends models.PeriodicBackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForPeriodicZabbixGovernance");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForPeriodicZabbixGovernance.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForPeriodicZabbixGovernance>): BackgroundJobPayloadForPeriodicZabbixGovernance {
        let obj = Object.assign(new BackgroundJobPayloadForPeriodicZabbixGovernance(), model);
        BackgroundJobPayloadForPeriodicZabbixGovernance.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForPeriodicZabbixGovernance>): BackgroundJobPayloadForPeriodicZabbixGovernance {
        if (!model) return null;
        return BackgroundJobPayloadForPeriodicZabbixGovernance.newInstance(<BackgroundJobPayloadForPeriodicZabbixGovernance> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForPeriodicZabbixGovernance) {
        if (!obj) return;

        models.BackgroundJobPayloadForPeriodicZabbixGovernance.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForPeriodicZabbixGovernance): boolean {
        if (models.PeriodicBackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForPeriodicZabbixGovernance.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
